import React from "react";
import styled, { css } from "styled-components";
import space from "../../../../../utils/space";
import unit from "../../../../../utils/unit";
import { PriceVariantType } from "../../priceMol.types";
var PointerSvg = function PointerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.244 6.484c-.772.036-1.244 0-1.244 0h1.244c1.655-.075 4.69-.476 7.417-2.243 1.092-.708 3.021-1.889 4.22-2.69C14.604.398 16 .501 16 .501S17.397.4 19.118 1.55c1.2.802 3.129 1.983 4.221 2.691 2.728 1.767 5.762 2.168 7.417 2.243H32s-.472.036-1.244 0H1.244Z",
    fill: "#E5F0F6"
  }));
};
PointerSvg.defaultProps = {
  width: "32",
  height: "7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export var PriceContainer = styled.div.withConfig({
  componentId: "sc-lhddg7-0"
})(function (_ref) {
  var $variant = _ref.$variant,
    $hasCrossedPriceSafeSpace = _ref.$hasCrossedPriceSafeSpace;
  return css(["position:relative;width:fit-content;", ""], $variant === PriceVariantType.LARGE ? css(["padding-bottom:0;", ""], $hasCrossedPriceSafeSpace ? css(["padding-top:", ";"], space(3)) : null) : null);
});
export var Pointer = styled(PointerSvg).withConfig({
  componentId: "sc-lhddg7-1"
})(function (_ref2) {
  var $position = _ref2.$position,
    $variant = _ref2.$variant;
  return css(["position:absolute;bottom:-", ";right:", ";width:", ";height:", ";", " ", ""], unit(5), unit($position), unit(32), unit(7), $variant.align === "left" ? css(["left:", ";"], unit($position)) : null, $variant.type === PriceVariantType.SMALL || $variant.type === PriceVariantType.MEDIUM ? css(["bottom:-", ";"], unit(1)) : null);
});